import * as React from 'react';

import MapContext           from './context';
import type { IMapContext } from './context';

const MapProvider: React.FC<React.ProviderProps<IMapContext>> = function(props) {
  const {
          children,
          value,
        } = props;

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
};

export default MapProvider;